import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const DiveCreatureSelector = ({
  creatures,
  selectedCreatures,
  setSelectedCreatures,
  inputValue,
  setInputValue,
}) => {
  return (
    <Autocomplete
      multiple
      options={creatures}
      getOptionLabel={(option) => option.label}
      value={selectedCreatures}
      onChange={(event, newValue) => {
        setSelectedCreatures(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => <TextField {...params} label="Creatures Seen" />}
      filterOptions={(options, { inputValue }) => {
        if (!inputValue) {
          return options;
        }
        return options.filter((option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
    />
  );
};

export default DiveCreatureSelector;
